import { initBotId } from "botid/client/core";
import { initPostHog } from "@/lib/analytics/posthog";
import { BOTID_PROTECTED_ROUTES } from "@/lib/botid/protected-routes";

/**
 * Browser-side PostHog boot.
 *
 * Next runs this module before hydration. It only schedules the SDK: posthog-js
 * is downloaded and initialised after the page has loaded (see initPostHog), so
 * it stays out of the first-load JS. IMPORTANT: never combine this with a
 * PostHogProvider or a second `posthog.init()`.
 */

if (!process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN && process.env.NODE_ENV !== "production") {
  console.error(
    "NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN is missing or un-configured, so browser events " +
      "are silently dropped. This stops once the variable is set."
  );
}

void initPostHog();

initBotId({ protect: BOTID_PROTECTED_ROUTES });
